







































































































































































































































































































import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
import httpApi from "@/API/Tenant/Weixin";
import "@/components/editor/tinymce.vue";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver";
const draggable = require("vuedraggable"); //引入拖动排序插件
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";

@Component({
  components: {
    Editor,
    draggable
  }
})
export default class extends Vue {
  @Provide() tenantsDialogVisible: boolean = false;
  @Prop() private propModuleData!: any;
  @Provide() disabled: false = false;
  @Prop({
    type: [String, Array],
    default:
      "undo redo | fontselect fontsizeselect hr | blockquote removeformat formatpainter  | link unlink openlink  emoticons | table   code |  bold  italic  underline strikethrough forecolor backcolor   |   alignleft aligncenter alignright alignjustify alignnone   | bullist numlist indent outdent  checklist    formatpainter    | subscript superscript |   formatselect  | lists image   insertvideo insertmusic   insertcard   preview "
  })
  @Provide() toolbar: any;
  @Provide() init: any = {
    selector: "#tinymce", //tinymce的id
    language_url: "/static/tinymce/langs/zh_CN.js",
    language: "zh_CN",
    skin_url: "/static/tinymce/skins/ui/oxide", //编辑器需要一个skin才能正常工作，所以要设置一个skin_url指向之前复制出来的skin文件
    menubar: false, //最上方menu
    inline: false, //
    statusbar: false, //状态栏
    toolbar_drawer: false, //工具栏浮动
    toolbar: this.toolbar, //工具栏 我用到的也就是lists image media table wordcount 这些 根据需求而定
    height: "100%"
  };
  created() {
   
  }
  addOption() {
    var content = this;
    var labeltxt =
      "选项" + (parseInt(content.propModuleData.options.length) + 1);
    content.propModuleData.options.push({ label: labeltxt, value: labeltxt });
    // this.$emit('radioAdd',this.propModuleData)
  }
  //上传背景图片
  async UploadImage(param: any) {
    let reader = new FileReader();
    let typeValue = "SmartFormImage";
    // console.log(param.data);
    reader.readAsDataURL(param.file);
    //console.log(reader);
    reader.onload = async e => {
      if (e.target) {
        let obj: any = (e.target as any).result;
        let params: any = {
          Input: [
            {
              Name: "Type",
              value: typeValue
            },
            {
              Name: "FileName",
              value: param.file.name
            },
            {
              Name: "FileBase64",
              value: obj
            }
          ]
        };
        // console.log(params);
        var res: any = await httpApi.SmartFormUploadVue(params);
        //console.log(res);
        if (res.ErrorCode == 0) {
          let valueStr = res.output[0].value;
          if (valueStr) {
            //console.log(valueStr);
            param.data.path = valueStr;
          }
        } else {
          this.$message.error("保存失败：" + res.ErrorMessage);
        }
      }
    };
  }
  //上传logo图片
  async UploadImageShare(param: any) {
    //console.log(param);
    let reader = new FileReader();
    let typeValue = "SmartFormImageShare";
    console.log(param);
    reader.readAsDataURL(param.file);
    //console.log(reader);
    reader.onload = async e => {
      if (e.target) {
        let obj: any = (e.target as any).result;
        let params: any = {
          Input: [
            {
              Name: "Type",
              value: typeValue
            },
            {
              Name: "FileName",
              value: param.file.name
            },
            {
              Name: "FileBase64",
              value: obj
            }
          ]
        };
        // console.log(params);
        var res: any = await httpApi.SmartFormUploadVue(params);
        //console.log(res);
        if (res.ErrorCode == 0) {
          let valueStr = res.output[0].value;
          if (valueStr) {
            //console.log(valueStr);
            param.data.logoImg = valueStr;
            // this.pageInfo.shareCoverImg = valueStr;
          }
        } else {
          this.$message.error("保存失败：" + res.ErrorMessage);
        }
      }
    };
  }
  //删除
  delOption(s: number) {
    var content = this;
    if (content.propModuleData.options.length > 1) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          content.propModuleData.options.splice(s, 1);
          if(content.propModuleData.apiName == 'optinsSelect'){
            if(content.propModuleData.maxSelect > content.propModuleData.options.length){
              content.propModuleData.maxSelect = content.propModuleData.options.length;
            }
            if(content.propModuleData.minSelect >= content.propModuleData.options.length){
              content.propModuleData.minSelect = content.propModuleData.maxSelect;
            }
          }
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
  addImgOption() {
    var content = this;
    var newImg = {
      path: "https://img.crd.cn/module/2020-04-27/750-950.jpg",
      describe: "这里输入图片描述，建议不超过20个字，可不填",
      url: "这里输入图片链接，可不填"
    };
    content.propModuleData.options.push(newImg);
  }
  // 限制多项选择的最大项数字
  checkMaxValue(numberValue:any){
    if(numberValue > this.propModuleData.options.length){
      this.propModuleData.maxSelect = this.propModuleData.options.length;
    }
    if(numberValue < this.propModuleData.minSelect){
      this.propModuleData.maxSelect = this.propModuleData.minSelect;
    }
  }
  checkMinValue(numberValue:any){
    if(numberValue <= 0){
      this.propModuleData.minSelect = 1;
    }
    if(numberValue > this.propModuleData.maxSelect){
      this.propModuleData.minSelect = this.propModuleData.maxSelect;
    }
  }
}
